import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reset } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import $ from 'jquery';


import * as actions from '../../actions';
import * as c from '../../constants';
import { getEditModalState } from '../../selectors';

import EditHotkeyForm from './forms/EditHotkeyForm';


class EditHotkeyModal extends Component {
  componentDidUpdate(prevProps) {
    const { isModalActive: prevState } = prevProps;
    const { isModalActive: currState } = this.props;

    if (prevState !== currState) {
      this.handleModalActive(currState);
    }
  }


  handleModalActive(showModal) {
    const { id, formId, resetEditModal, reset } = this.props;

    if (showModal) {
      $(`#${id}`).modal({
        closable: false,
        onHidden() {
          reset(formId);
          resetEditModal();
        }
      }).modal('show');
    } else {
      $(`#${id}`).modal('hide');
    }
  }


  render() {
    const { id, formId } = this.props;

    return (
      <div className="ui small compact modal" id={id}>
        <i className="close icon" />
        <div className="header" style={{ paddingTop: 15 }}>
          <FormattedMessage id="admin.hotkey_template.form.edit" defaultMessage="Edit" />
        </div>
        <div className="content ht-paddingless">
          <EditHotkeyForm formId={formId} />
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  const formId = c.FORM_ID_EDIT_MODAL;
  const { isModalActive = false } = getEditModalState(state);

  return {
    formId,
    isModalActive
  };
}


function mapDispatchToProps(dispatch) {
  const { resetEditModal } = actions;

  return bindActionCreators({
    reset,
    resetEditModal
  }, dispatch);
}


export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(EditHotkeyModal));

